import React from "react";
import {useTranslation} from "react-i18next";
import MDButton from "../../../materialDashboard/components/MDButton";
import Stack from "@mui/material/Stack";
import {isAfter, startOfDay} from "date-fns";

const ActivationButtons = ({formik, station}) => {
    const {t} = useTranslation(['stations']);

    // Se stiamo creando una stazione, non mostriamo nulla
    if (!station) return null;

    const {activatedAt, deactivatedAt} = formik.values;
    const today = startOfDay(new Date());
    const currentlyActive = station.currentlyActive;

    const handleActivate = () => {
        if(activatedAt && isAfter(startOfDay(activatedAt), today)){
            formik.setFieldValue("activatedAt", today);
        }
        if (deactivatedAt && !isAfter(startOfDay(deactivatedAt), today)) {
            formik.setFieldValue("deactivatedAt", null);
        }
    };

    const handleDeactivate = () => {
        formik.setFieldValue("deactivatedAt", today);
    };

    const handleUndo = () => {
        formik.setFieldValue("activatedAt", formik.initialValues.activatedAt);
        formik.setFieldValue("deactivatedAt", formik.initialValues.deactivatedAt);
    };

    const isDirty = formik.initialValues.activatedAt !== activatedAt || formik.initialValues.deactivatedAt !== deactivatedAt;

    return (
        <Stack direction="row" spacing={2} mt={2}>

            {isDirty ?
                <MDButton
                    variant="text"
                    color="info"
                    size="small"
                    onClick={handleUndo}
                >
                    {t('stationForm.undoStatus')}
                </MDButton>
                :
                <>
                    {
                        currentlyActive ? (
                            <MDButton
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={handleDeactivate}
                                disabled={isDirty}
                            >
                                {t('stationForm.deactivate')}
                            </MDButton>
                        ) : (
                            <MDButton
                                variant="outlined"
                                color="success"
                                size="small"
                                onClick={handleActivate}
                                disabled={isDirty}
                            >
                                {t('stationForm.activate')}
                            </MDButton>
                        )
                    }
                </>
            }
        </Stack>
    );
};

export default ActivationButtons;
